import React from "react";
import { Field } from "formik";

import { FormSelect } from "../../../../../components/ui";
import { EXCHANGES_OPTIONS } from "../constants";

const ExchangesSelect: React.FC = () => (
  <Field
    name="exchanges"
    label="Exchanges"
    placeholder="Exchanges"
    multiple
    component={FormSelect}
    options={EXCHANGES_OPTIONS}
  />
);

export default ExchangesSelect;
